<template>
  <v-card flat style="background-color:#e9e9e9;">
   
    <v-tabs  fixed-tabs elevation-0  style="background-color:#e9e9e9;">
      <v-tab @change="changetab('Card Master')">
        <v-icon left>
          mdi-bank
        </v-icon>
        Card Setup
      </v-tab>
     
      <v-tab @change="changetab('Card + Event - Mapping')">
        <v-icon left>
          mdi-account-network
        </v-icon>
       Card + Event
      </v-tab>

      <v-tab-item >
        <card></card>
      </v-tab-item>
     
      <v-tab-item style="background-color:#e9e9e9;">
       <cardEventmerge></cardEventmerge>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
import card from '../../../components/card'
import cardEventmerge from '../../../components/cardEventmerge.vue'
export default {
 components: {card,cardEventmerge},
  methods:{
    changetab: function(pagename) {
        this.$store.commit("setPageTitle", pagename);
    }
 }
  
}
</script>